// extracted by mini-css-extract-plugin
export default {"wrapper":"O6-z","play":"P6-z"};